import { Flex } from '@utilitywarehouse/hearth-react';
import {
  BroadbandMediumIcon,
  CashbackCardMediumIcon,
  ElectricityMediumIcon,
  HomeAndBoilerMediumIcon,
  IncomeProtectMediumIcon,
  InsuranceMediumIcon,
  MobileMediumIcon,
} from '@utilitywarehouse/hearth-react-icons';

import { ProductSubtype, ProductType } from '@generated/gql/graphql';

import './styles.scss';

interface ProductIndicatorProps {
  productType: ProductType;
  subType?: ProductSubtype;
}

const getProductIcon = (productType: ProductType, subType?: ProductSubtype) => {
  switch (productType) {
    case ProductType.Energy:
      return ElectricityMediumIcon;
    case ProductType.Broadband:
      return BroadbandMediumIcon;
    case ProductType.Mobile:
      return MobileMediumIcon;
    case ProductType.Insurance:
      if (subType === ProductSubtype.BoilerHomeCover)
        return HomeAndBoilerMediumIcon;
      if (subType === ProductSubtype.IncomeProtector)
        return IncomeProtectMediumIcon;
      return InsuranceMediumIcon;
    case ProductType.CashbackCard:
      return CashbackCardMediumIcon;
    default:
      return null;
  }
};

const getProductColorClass = (productType: ProductType) => {
  switch (productType) {
    case ProductType.Energy:
      return 'product-indicator--energy';
    case ProductType.Broadband:
      return 'product-indicator--broadband';
    case ProductType.Mobile:
      return 'product-indicator--mobile';
    case ProductType.Insurance:
      return 'product-indicator--insurance';
    case ProductType.CashbackCard:
      return 'product-indicator--cashback';
    default:
      return '';
  }
};

const ProductIndicator = ({ productType, subType }: ProductIndicatorProps) => {
  const Icon = getProductIcon(productType, subType);

  if (!Icon) {
    return null;
  }

  return (
    <Flex
      className={`product-indicator ${getProductColorClass(productType)}`}
      justifyContent="center"
      alignItems="center"
    >
      <Icon />
    </Flex>
  );
};

export { ProductIndicator };
